import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import { getLocale } from "react-i18nify";
import styled from "styled-components";

import {
  getQuotationDraftDetail,
  getGenerateDraftPdf,
  approveQuotationDraft,
} from "src/api/quotationDraft";

import device from "src/styles/device";
import font from "src/styles/font";
import useDeviceSize from "src/hooks/useDeviceSize";
import { checkNotEmpty } from "src/common";

import * as MatStyled from "@mui/material/styles";
import {
  TextField,
  Grid,
  Stack,
  Alert,
  Box,
  IconButton,
  FormControlLabel,
  Checkbox,
  Chip,
} from "@mui/material";
import Button from "src/components/core/Button";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CloseIcon from "@mui/icons-material/Close";
import ErrorSharpIcon from "@mui/icons-material/ErrorSharp";
import DownloadSharpIcon from "@mui/icons-material/DownloadSharp";

import Loading from "src/components/ui/Loading";

import DocumentGrid from "./CreateQuoDraft/DocumentGrid";
import SummaryDetailGrid from "./CreateQuoDraft/SummaryDetailGrid";
import UploadPdf from "src/components/upload/dropzone/UploadPdf";
import ModalRequest from "src/components/quotation-draft/ModalRequestQuotation";

const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  position: relative;
  margin: 0 auto;
  padding: 32px;

  @media ${device.tabletL} {
    padding: 24px 0;
  }
`;

const SpanTitle = styled.div`
  color: #000;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 40px;
  text-align: center;

  @media ${device.tabletL} {
    margin-bottom: 0;
  }
`;

const Content = styled.div`
  width: 100%;

  @media ${device.tabletL} {
    margin-bottom: ${({ docStatus }) => (docStatus === 2 ? "120px" : "170px")};
  }
`;

const TextRemark = styled(Box)`
  width: 100%;
  color: var(--darkgrey-color);
  font-size: ${font.size.sm};
  font-weight: 400;
  line-height: 2.2;
  padding: 16px;
  white-space: pre-line;
  word-break: break-word;

  @media ${device.mobileL} {
    padding: 16px 10px;
  }
`;

const AttachTitle = styled.div`
  font-size: ${font.size.lg};
  font-weight: 400;
  color: var(--secondary-color);
  margin-bottom: 24px;

  @media ${device.tabletL} {
    font-size: ${font.size.md};
  }
`;

const WrapperTextField = styled.div`
  // margin-bottom: 16px;
  width: 100%;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 16px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiOutlinedInput-input {
    background: #fff;

    border-radius: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }
`;

const ButtonGroup = styled(Stack)`
  width: 100%;
  max-width: 1240px;
  z-index: 15;
  background-color: var(--white-color);
  margin-top: 40px;

  @media ${device.tabletL} {
    position: fixed;
    bottom: 0;
    width: -webkit-fill-available;
    min-height: 110px;
    padding: 32px 20px;
    border-radius: 24px 24px 0 0;
    box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);

    .MuiButton-root {
      padding: 8px 24px;
    }
  }
`;

const WrapperAlert = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  z-index: 3000;
  animation: showAlert 0.5s;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  @keyframes showAlert {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
`;

const DivAlert = styled.div`
  min-width: 320px;
  width: fit-content;
  .MuiPaper-root-MuiAlert-root {
    border-radius: 16px;
  }
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginTop: "75px",
  width: "100%",
  height: "calc(100dvh - 75px)",
  overflow: "hidden",
  overflowY: "scroll",
  scrollBehavior: "smooth",
  background: "#fff",
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
  [theme.breakpoints.down("sm")]: {
    marginTop: "64px",
    height: "calc(100vh - 64px)",
  },
}));

const QuoDraftDetail = ({ open }) => {
  let { quotationId } = useParams();
  const navigate = useNavigate();

  const [quoDraftData, setQuoDraftData] = useState({});
  const [updateQuoPdf, setUpdateQuoPdf] = useState({});
  const [isRequirePdf, setIsRequirePdf] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const initialAlert = {
    visible: false,
    textError: "",
    typeError: "success",
  };
  const [alertInfo, setAlertInfo] = useState(initialAlert);
  const initialRequest = {
    visible: false,
    // callback: () => {},
    // onSubmit: () => {},
  };
  const [requestInfo, setRequestInfo] = useState(initialRequest);

  const [deviceWidth] = useDeviceSize();

  const fecthQuoData = async () => {
    await getQuotationDraftDetail(quotationId)
      .then(async ({ data }) => {
        // console.log('---data---', data);
        setQuoDraftData({
          ...data,
          // ...(data.document_type === "product" && ({
          //   product_list: data.quotation_list
          // })),
          // ...(data.document_type === "service" && ({
          //   service_list: data.quotation_list
          // })),
          // ...(data.document_type === "other" && ({
          //   document_type: "product",
          //   other_list: data.quotation_list
          // })),
        });
      })
      .catch((err) => {
        console.log("error", err.response.data.message);
        navigate("/404");
      });
  };

  useEffect(() => {
    if (quotationId === undefined) return;

    fecthQuoData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotationId]);

  const shareGeneratePdf = async () => {
    setIsLoading(true);
    await getGenerateDraftPdf(quotationId)
      .then(async ({ data }) => {
        if (data) {
          setIsLoading(false);
          await window.open(data.deposit_pdf, "_blank");
        }
        fecthQuoData();
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("error", err.response.data.message);
        setAlertInfo({
          ...alertInfo,
          visible: true,
          textError: err.response.data.message,
          typeError: "error",
        });
        console.log("error: ", err.response);
        setTimeout(() => {
          setAlertInfo(initialAlert);
        }, 1500);
      });
  };

  const updateQuotation = async () => {
    setIsLoading(true);

    let data = new FormData();

    Object.keys(updateQuoPdf).forEach((key) => {
      data.append(key, updateQuoPdf[key]);
      return data;
    });

    await approveQuotationDraft(quotationId, data)
      .then((res) => {
        setIsLoading(false);
        setAlertInfo({
          ...alertInfo,
          visible: true,
          textError: "Update Success!",
          typeError: "success",
        });
        fecthQuoData();
        setTimeout(() => {
          setAlertInfo(initialAlert);
        }, 1500);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertInfo({
          ...alertInfo,
          visible: true,
          textError: err.response.data.message,
          typeError: "error",
        });
        console.log("error: ", err.response);
        setTimeout(() => {
          setAlertInfo(initialAlert);
        }, 1500);
      });
  };

  return (
    <>
      <Main open={open}>
        <Container>
          <SpanTitle>ใบเสนอราคาชั่วคราว</SpanTitle>

          <Content docStatus={quoDraftData?.status}>
            {/* Summary detail */}
            <SummaryDetailGrid formData={quoDraftData} />

            {/* Product Table */}
            <DocumentGrid isDetail={true} formData={quoDraftData} />

            {/* Remark */}
            <Grid
              container
              sx={{
                mt: 3,
                px: {
                  xs: 3,
                  sm: 5,
                  md: 0,
                },
                fontSize: font.size.md,
                ".MuiAutocomplete-root": {
                  margin: 0,
                },
                ".MuiTextField-root": {
                  borderRadius: "24px",
                },
                ".MuiOutlinedInput-root": {
                  borderRadius: "24px",
                },
                ".MuiInputBase-inputMultiline": {
                  p: 0,
                  textAlign: "left",
                },
                ".MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input":
                  {
                    px: 0,
                  },
              }}
            >
              {quoDraftData?.remark !== "" ? (
                <Grid
                  item
                  xs={12}
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: {
                      xs: "center",
                      md: "flex-start",
                    },
                    justifyContent: "center",
                  }}
                >
                  <TextRemark>{quoDraftData?.remark}</TextRemark>
                </Grid>
              ) : null}
            </Grid>

            {quoDraftData?.status !== 2 &&
              (deviceWidth > 835 ? (
                <Grid
                  container
                  sx={{
                    m: 0,
                    mt: 3,
                    px: 3,
                    py: { xs: 3, sm: 5 },
                    width: "100%",
                    borderRadius: { md: "24px" },
                    background: "var(--white-color)",
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
                  }}
                >
                  {/* main pdf */}
                  <Grid item xs={12} sx={{ mb: 3 }}>
                    <AttachTitle>แนบใบเสนอราคา (My Account)</AttachTitle>

                    <WrapperTextField>
                      <TextField
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <>
                              {checkNotEmpty(updateQuoPdf?.quotation_pdf) ? (
                                <IconButton
                                  sx={{ padding: 0 }}
                                  onClick={() => {
                                    setUpdateQuoPdf({
                                      ...updateQuoPdf,
                                      quotation_pdf: "",
                                    });
                                  }}
                                >
                                  <CloseIcon
                                    sx={{ color: "#e04132", cursor: "pointer" }}
                                  />
                                </IconButton>
                              ) : (
                                <UploadPdf
                                  callBackFile={(fileCallBlack) => {
                                    setUpdateQuoPdf({
                                      ...updateQuoPdf,
                                      quotation_pdf: fileCallBlack,
                                    });
                                  }}
                                  closeAlert={false}
                                >
                                  <PictureAsPdfIcon
                                    sx={{
                                      color:
                                        updateQuoPdf?.quotation_pdf !== null &&
                                        updateQuoPdf?.quotation_pdf !== "" &&
                                        updateQuoPdf?.quotation_pdf !==
                                          undefined
                                          ? "#e04132"
                                          : "rgba(0, 0, 0, 0.54)",
                                      cursor: "pointer",
                                      ":hover": {
                                        color: "#e04132",
                                      },
                                    }}
                                  />
                                </UploadPdf>
                              )}
                            </>
                          ),
                        }}
                        InputLabelProps={{ shrink: true }}
                        label="PDF My Account"
                        variant="outlined"
                        className="TextField-without-border-radius"
                        sx={{
                          width: "100%",
                          textAlign: "left",
                          background: "#fff",
                          borderRadius: "16px",
                          ".MuiFormHelperText-root": {
                            m: 0,
                            mt: 2,
                          },
                        }}
                        value={
                          typeof updateQuoPdf?.quotation_pdf !== "object"
                            ? updateQuoPdf?.quotation_pdf
                            : updateQuoPdf?.quotation_pdf?.name || ""
                        }
                        helperText={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              fontSize: font.size.sm,
                            }}
                          >
                            <ErrorSharpIcon
                              sx={{ width: 20, height: 20, color: "#E6B558" }}
                            />
                            หากแนบใบเสนอราคาจาก My Account แล้วกด Request
                            Quotation
                            แล้วนั้นใบเสนอราคาชั่วคราวนี้จะกลายเป็นใบที่เสร็จสมบูรณ์
                          </Box>
                        }
                      />
                    </WrapperTextField>
                  </Grid>

                  {/* addition pdf */}
                  <Grid item xs={12} sx={{ mb: 2 }}>
                    <AttachTitle>แนบเอกสารเพิ่มเติม (หากมี)</AttachTitle>

                    <WrapperTextField>
                      <TextField
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <>
                              {checkNotEmpty(
                                updateQuoPdf?.additional_quotation_pdf,
                              ) ? (
                                <IconButton
                                  sx={{ padding: 0 }}
                                  onClick={() => {
                                    setUpdateQuoPdf({
                                      ...updateQuoPdf,
                                      additional_quotation_pdf: "",
                                    });
                                  }}
                                >
                                  <CloseIcon
                                    sx={{ color: "#e04132", cursor: "pointer" }}
                                  />
                                </IconButton>
                              ) : (
                                <UploadPdf
                                  callBackFile={(fileCallBlack) => {
                                    setUpdateQuoPdf({
                                      ...updateQuoPdf,
                                      additional_quotation_pdf: fileCallBlack,
                                    });
                                  }}
                                  closeAlert={false}
                                >
                                  <PictureAsPdfIcon
                                    sx={{
                                      color:
                                        updateQuoPdf?.additional_quotation_pdf !==
                                          null &&
                                        updateQuoPdf?.additional_quotation_pdf !==
                                          "" &&
                                        updateQuoPdf?.additional_quotation_pdf !==
                                          undefined
                                          ? "#e04132"
                                          : "rgba(0, 0, 0, 0.54)",
                                      cursor: "pointer",
                                      ":hover": {
                                        color: "#e04132",
                                      },
                                    }}
                                  />
                                </UploadPdf>
                              )}
                            </>
                          ),
                        }}
                        InputLabelProps={{ shrink: true }}
                        label="PDF My Account"
                        variant="outlined"
                        className="TextField-without-border-radius"
                        sx={{
                          width: "100%",
                          textAlign: "left",
                          background: "#fff",
                          borderRadius: "16px",
                        }}
                        value={
                          typeof updateQuoPdf?.additional_quotation_pdf !==
                          "object"
                            ? updateQuoPdf?.additional_quotation_pdf
                            : updateQuoPdf?.additional_quotation_pdf?.name || ""
                        }
                      />
                    </WrapperTextField>
                  </Grid>

                  <Grid item xs={12}>
                    <FormControlLabel
                      label={`ต้องให้ Admin ออกเอกสารใบเสนอราคาตัวจริงจาก My Account`}
                      sx={{ width: "100%", mr: 0, mb: -1 }}
                      control={
                        <Checkbox
                          sx={{
                            p: 1,
                            color: "var(--primary-color)",
                            "&.Mui-checked": {
                              color: "var(--primary-color)",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: 24,
                            },
                          }}
                          disabled={quoDraftData?.status !== 0}
                          checked={
                            quoDraftData?.status === 0
                              ? isRequirePdf
                              : quoDraftData?.status === 1
                          }
                          onChange={(e) => {
                            setIsRequirePdf(e.target.checked);
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  container
                  sx={{
                    m: 0,
                    mt: 3,
                    px: {
                      xs: 3,
                      sm: 5,
                    },
                    pb: 2,
                    width: "100%",
                    borderRadius: { md: "24px" },
                    background: "var(--white-color)",
                  }}
                >
                  <Grid item xs={12}>
                    <FormControlLabel
                      label={`ต้องให้ Admin ออกเอกสารใบเสนอราคาตัวจริงจาก My Account`}
                      sx={{
                        width: "100%",
                        mr: 0,
                        mb: -1,
                        fontSize: {
                          xs: font.size.sm,
                          sm: font.size.md,
                        },
                      }}
                      control={
                        <Checkbox
                          sx={{
                            p: 1,
                            color: "var(--primary-color)",
                            "&.Mui-checked": {
                              color: "var(--primary-color)",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: 24,
                            },
                          }}
                          disabled={quoDraftData?.status !== 0}
                          checked={
                            quoDraftData?.status === 0
                              ? isRequirePdf
                              : quoDraftData?.status === 2 &&
                                  quoDraftData?.quotation_pdf_links?.length < 1
                                ? false
                                : quoDraftData?.status === 1
                          }
                          onChange={(e) => {
                            setIsRequirePdf(e.target.checked);
                          }}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              ))}

            {quoDraftData?.status === 2 &&
              quoDraftData?.quotation_pdf_links?.length > 0 && (
                <Grid
                  container
                  sx={{
                    m: 0,
                    mt: 3,
                    mx: {
                      xs: 3,
                      sm: 5,
                      md: 0,
                    },
                    px: 3,
                    py: { xs: 3, sm: 5 },
                    width: {
                      xs: "calc(100% - 48px)",
                      sm: "calc(100% - 80px)",
                      md: "100%",
                    },
                    borderRadius: "24px",
                    background: "var(--white-color)",
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
                  }}
                >
                  {/* main pdf */}
                  <Grid item xs={12} sx={{ mb: 3 }}>
                    <AttachTitle>แนบใบเสนอราคา (My Account)</AttachTitle>

                    <Chip
                      label={
                        quoDraftData?.quotation_pdf_links[0]?.quotation_pdf_link
                      }
                      sx={{
                        height: "auto",
                        marginBottom: "16px",
                        ".MuiChip-label": {
                          fontSize: "1rem",
                          color: "#6C6C70",
                          padding: "10px 20px",
                          textDecoration: "underline",
                        },
                        ":last-child": {
                          marginBottom: 0,
                        },
                      }}
                      onClick={() => {
                        window.open(
                          quoDraftData?.quotation_pdf_links[0]
                            ?.quotation_pdf_link,
                          "_blank",
                        );
                      }}
                    />
                  </Grid>

                  {/* addition pdf */}
                  {checkNotEmpty(quoDraftData?.quotation_pdf_links[1]) ? (
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <AttachTitle>แนบเอกสารเพิ่มเติม (หากมี)</AttachTitle>

                      <Chip
                        label={
                          quoDraftData?.quotation_pdf_links[1]
                            ?.quotation_pdf_link
                        }
                        sx={{
                          height: "auto",
                          marginBottom: "16px",
                          ".MuiChip-label": {
                            fontSize: "1rem",
                            color: "#6C6C70",
                            padding: "10px 20px",
                            textDecoration: "underline",
                          },
                          ":last-child": {
                            marginBottom: 0,
                          },
                        }}
                        onClick={() => {
                          window.open(
                            quoDraftData?.quotation_pdf_links[1]
                              ?.quotation_pdf_link,
                            "_blank",
                          );
                        }}
                      />
                    </Grid>
                  ) : null}
                </Grid>
              )}
          </Content>

          <ButtonGroup
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            rowGap={2}
          >
            {quoDraftData?.status === 2 ? (
              <Button
                variant="contained"
                size="large"
                onClick={() => {
                  if (checkNotEmpty(quoDraftData?.share_pdf_link))
                    window.open(quoDraftData?.share_pdf_link, "_blank");
                  else shareGeneratePdf();
                }}
                sx={{
                  width: "100%",
                  maxWidth: 300,
                  borderRadius: 4,
                }}
                startIcon={<DownloadSharpIcon />}
              >
                Download PDF (Draft)
              </Button>
            ) : (
              <>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => {
                    if (checkNotEmpty(quoDraftData?.share_pdf_link))
                      window.open(quoDraftData?.share_pdf_link, "_blank");
                    else shareGeneratePdf();
                  }}
                  sx={{
                    width: "100%",
                    maxWidth: 300,
                    borderRadius: 4,
                    "&.MuiButton-contained": {
                      backgroundColor: "#F7CECB",
                      color: "#e04132",
                      ":disabled": {
                        opacity: 0.5,
                      },
                    },
                  }}
                >
                  Share PDF (Draft)
                </Button>

                <Button
                  variant="contained"
                  size="large"
                  disabled={
                    deviceWidth > 835
                      ? quoDraftData?.status === 1 &&
                        !checkNotEmpty(updateQuoPdf?.quotation_pdf)
                      : // || (!isRequirePdf && !checkNotEmpty(updateQuoPdf?.quotation_pdf))
                        quoDraftData?.status === 1
                  }
                  onClick={() => {
                    if (quoDraftData?.status === 0)
                      setRequestInfo((prev) => ({
                        ...prev,
                        visible: true,
                      }));
                    else updateQuotation();
                  }}
                  sx={{ width: "100%", maxWidth: 300, borderRadius: 4 }}
                >
                  {(quoDraftData?.status === 0 &&
                    !checkNotEmpty(updateQuoPdf?.quotation_pdf)) ||
                  deviceWidth <= 835
                    ? // (isRequirePdf && quoDraftData?.status === 0) || deviceWidth <= 835
                      `Send to admin`
                    : `Attach PDF`}
                </Button>
              </>
            )}
          </ButtonGroup>
        </Container>

        {alertInfo.visible && (
          <WrapperAlert>
            <DivAlert>
              <Alert
                className="MuiPaper-root-MuiAlert-root"
                severity={alertInfo.typeError}
              >
                {alertInfo.textError}
              </Alert>
            </DivAlert>
          </WrapperAlert>
        )}

        <ModalRequest
          quotationId={quotationId}
          isOpen={requestInfo.visible}
          onClose={() => setRequestInfo(initialRequest)}
          onDismiss={fecthQuoData}
          requirePdf={isRequirePdf}
        />
      </Main>

      {isLoading && <Loading />}
    </>
  );
};

export default QuoDraftDetail;
